import { FormBase } from 'core/components';

export default class ProductTypeEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'PRODUCT_TYPE.EDIT.NAME_LABEL',
                    placeholder: 'PRODUCT_TYPE.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
                {
                    name: 'itemCategoryId',
                    label: 'PRODUCT_TYPE.EDIT.CATEGORY_LABEL',
                    placeholder: 'PRODUCT_TYPE.EDIT.CATEGORY_PLACEHOLDER',
                    rules: "required",
                },
                {
                    name: 'defaultItemTypeTags',
                    label: 'PRODUCT_TYPE.EDIT.TAGS_LABEL',
                    placeholder: 'PRODUCT_TYPE.EDIT.TAGS_PLACEHOLDER'
                },
            ],
        };
    }
}
